module.exports = __webpack_public_path__ + "public/img/维修中.71888cd0.png";